import script from "./JaStreamGroupUploadStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupUploadStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupUploadStatusBadge.vue?vue&type=style&index=0&id=a5f68da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5f68da6"]])

export default __exports__